import {
  getLocalStorage,
  getSessionStorage,
  getWebStorageEntry,
  removeWebStorageEntry,
  setWebStorageEntry,
} from 'src/utils/webStorageUtils';

const getWebStorageArrayEntry = (getStorage: () => Storage, name: string): string[] => {
  const data = getWebStorageEntry(getStorage, name);
  return data ? data.split(',') : [];
};

export const hasInWebStorageArrayEntry = (
  getStorage: () => Storage,
  name: string,
  value: string,
): boolean => getWebStorageArrayEntry(getStorage, name).includes(value);

export const addToWebStorageArrayEntry = (
  getStorage: () => Storage,
  name: string,
  value: string,
): boolean => {
  if (hasInWebStorageArrayEntry(getStorage, name, value)) {
    return false;
  }

  const oldArr = getWebStorageArrayEntry(getStorage, name);
  const newArr = [...oldArr, value];
  setWebStorageEntry(getStorage, name, newArr.join(','));
  return true;
};

export const removeFromWebStorageArrayEntry = (
  getStorage: () => Storage,
  name: string,
  value: string,
): boolean => {
  const oldArr = getWebStorageArrayEntry(getStorage, name);
  const newArr = oldArr.filter(a => a !== value);

  if (newArr.length > 0) {
    setWebStorageEntry(getStorage, name, newArr.join(','));
  } else {
    removeWebStorageEntry(getStorage, name);
  }

  return oldArr.length > newArr.length;
};

export const hasInLocalStorageArrayEntry = (name: string, value: string) =>
  hasInWebStorageArrayEntry(getLocalStorage, name, value);

export const addToLocalStorageArrayEntry = (name: string, value: string) =>
  addToWebStorageArrayEntry(getLocalStorage, name, value);

export const removeFromLocalStorageArrayEntry = (name: string, value: string) =>
  removeFromWebStorageArrayEntry(getLocalStorage, name, value);

export const hasInSessionStorageArrayEntry = (name: string, value: string) =>
  hasInWebStorageArrayEntry(getSessionStorage, name, value);

export const addToSessionStorageArrayEntry = (name: string, value: string) =>
  addToWebStorageArrayEntry(getSessionStorage, name, value);

export const removeFromSessionStorageArrayEntry = (name: string, value: string) =>
  removeFromWebStorageArrayEntry(getSessionStorage, name, value);
